import { setTheme } from "theme/default/setTheme";

export const borderRadius_8px = setTheme(({ theme }) => theme.borderRadius.border_radius_8px);
